import axios from "axios";
const baseUrl = "/api/v1";
const queryString = require("query-string");
import { useCookies } from "vue3-cookies";
const { cookies } = useCookies();

const config = {
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
    Cookie: "token=" + cookies.get("token"),
  },
};

// This file specifically will be for authentication related
export const auth = {
  login: (payload) =>
    axios.post(`${baseUrl}/auth/login`, queryString.stringify(payload), config),
  logout: (payload) =>
    axios.post(
      `${baseUrl}/auth/logout`,
      queryString.stringify(payload),
      config
    ),
};
